import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function CargaMasivaDeGuias() {
  return (
    <ClipperPlaceholder title="Carga Masiva de Guías" category="Operativas" />
  );
}
